/*! js-cookie v3.0.5 | MIT */
function f(e) {
  for (var i = 1; i < arguments.length; i++) {
    var s = arguments[i];
    for (var d in s)
      e[d] = s[d];
  }
  return e;
}
var v = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function u(e, i) {
  function s(o, c, n) {
    if (!(typeof document > "u")) {
      n = f({}, i, n), typeof n.expires == "number" && (n.expires = new Date(Date.now() + n.expires * 864e5)), n.expires && (n.expires = n.expires.toUTCString()), o = encodeURIComponent(o).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var r = "";
      for (var t in n)
        n[t] && (r += "; " + t, n[t] !== !0 && (r += "=" + n[t].split(";")[0]));
      return document.cookie = o + "=" + e.write(c, o) + r;
    }
  }
  function d(o) {
    if (!(typeof document > "u" || arguments.length && !o)) {
      for (var c = document.cookie ? document.cookie.split("; ") : [], n = {}, r = 0; r < c.length; r++) {
        var t = c[r].split("="), l = t.slice(1).join("=");
        try {
          var p = decodeURIComponent(t[0]);
          if (n[p] = e.read(l, p), o === p)
            break;
        } catch {
        }
      }
      return o ? n[o] : n;
    }
  }
  return Object.create(
    {
      set: s,
      get: d,
      remove: function(o, c) {
        s(
          o,
          "",
          f({}, c, {
            expires: -1
          })
        );
      },
      withAttributes: function(o) {
        return u(this.converter, f({}, this.attributes, o));
      },
      withConverter: function(o) {
        return u(f({}, this.converter, o), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(i) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var a = u(v, { path: "/" });
const g = () => typeof window < "u" && typeof window.document < "u", C = () => !g(), h = (e) => e.startsWith("beta"), m = () => a.get("IS_CANARY") === "true", x = () => a.get("fondof_internal") === "true", I = (e) => e.includes("stage."), R = (e) => e.includes("dev.") || e.includes("localhost"), U = (e) => e.includes("www.");
export {
  h as isBeta,
  g as isBrowser,
  m as isCanary,
  R as isDev,
  x as isInternal,
  U as isProd,
  C as isSSR,
  I as isStage
};
//# sourceMappingURL=env.js.map
